module.exports = __webpack_public_path__ + "static/media/04.3b2d2daf.jpg";